import {base_url} from '../common/config';
import store from '../store/storeProvider';

export const organizationalUrl = () => {
  const {authentication} = store.getState();
  const organization = authentication.organization;
  return `${base_url}/${organization}`;
};

